import AppContext from "AppContext";
import { GFComboField } from "components/GeneralForm";
import { GFTextField } from "components/GeneralForm";
import { GFDateField } from "components/GeneralForm";
import { GFIntegerField } from "components/GeneralForm";
import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import comboService from "services/ComboService";
import { getStatusOrdemServicoDescription, statusOrdemServicoList } from "services/OrdemServicoService";
import { PapelEnum } from "services/PerfilService";
import relatorioService from "services/RelatorioService";
import { erroInesperado } from "services/Utils";
import ModalAvisosRelatorio from "components/ModalAvisosRelatorio";

const statusOrdemServicoOptions = statusOrdemServicoList.map(id => ({
  id,
  nome: getStatusOrdemServicoDescription(id)
}))

export default function Relatorios() {
  const [contratos, setContratos] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [equipes, setEquipes] = useState([])
  const [lotes, setLotes] = useState([])
  const [relatorioComAvisos, setRelatorioComAvisos] = useState(false)
  const [data, setData] = useState({
    tipo: 'por_filtros'
  })
  const { state } = useContext(AppContext)

  const idTipoPerfil = state?.user?.perfil?.idTipo || 0
  const acoesUsuario = state?.user?.acoes || []

  useEffect(() => {

    if (idTipoPerfil != PapelEnum.FISCAL && idTipoPerfil != PapelEnum.GESTOR_EMPRESA && idTipoPerfil != PapelEnum.GESTOR_CONTRATO) {
      comboService.contrato().then(res => {
        if (res.success) {
          setContratos(res.data)
        }
      })
    }

    if (acoesUsuario.includes('relatorio.gerar_por_lote')) {
      comboService.lote().then(res => {
        if (res.success) {
          setLotes(res.data)
        }
      })
    }

    const idContrato = state?.contrato?.id

    const hoje = new Date()
    const dataInicio = new Date(hoje.getTime())
    dataInicio.setDate(1)
    const dataFim = new Date(hoje.getTime())
    dataFim.setHours(0, 0, 0, 0)

    setData({ ...data, dataInicio, dataFim, idContrato })
  }, [])

  useEffect(() => {
    if (!data.idContrato) {
      setEmpresas([])
      return
    }

    comboService.empresa(data.idContrato).then(res => {
      if (res.success) {
        setEmpresas(res.data)
      }
    })
  }, [data.idContrato])

  useEffect(() => {
    setEquipes([])
    if (data.idEmpresa) {
      comboService.equipes(data.idEmpresa).then(res => {
        if (res.success) {
          setEquipes(res.data)
        }
      })
    }
  }, [data.idEmpresa])

  const handleChange = (field, value) => {
    setData(data => {
      const newData = { ...data, [field]: value }

      if (field === 'idContrato') {
        newData.idEmpresa = null
        newData.idEquipe = null
      }

      if (field === 'idEmpresa') {
        newData.idEquipe = null
      }

      return newData
    })
  }

  const handleSubmit = async ev => {
    ev.preventDefault()
    switch (data.tipo) {
      case 'por_filtros': return await submitPorFiltros()
      case 'por_lote': return await submitPorLote()
    }
  }

  const submitPorFiltros = async () => {
    const errors = []
    if (idTipoPerfil != PapelEnum.FISCAL && idTipoPerfil != PapelEnum.GESTOR_EMPRESA && idTipoPerfil != PapelEnum.GESTOR_CONTRATO && !data.idContrato) {
      errors.push({ fieldName: 'idContrato', error: 'Selecione o contrato' })
    }

    const temFiltro = !!(data.numero || data.ano || data.idEmpresa || data.osInicio || data.osFim || data.idStatus || data.dataInicio || data.dataFim)
    if (!temFiltro) {
      errors.push({ fieldName: 'numero', error: 'Informe ao menos um filtro' })
    }

    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      showLoading()
      const avisos = await relatorioService.gerarPorFiltros(data.idContrato, {
        numero: data.numero,
        ano: data.ano,
        idEmpresa: data.idEmpresa,
        idEquipe: data.idEquipe,
        osInicio: data.osInicio,
        osFim: data.osFim,
        idStatus: data.idStatus,
        dataInicio: data.dataInicio,
        dataFim: data.dataFim,
      })
      hideLoading()
      if (avisos > 0)
        setRelatorioComAvisos(true)
    } catch (ex) {
      hideLoading()
      if (ex.status == 422) {
        if (ex.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const result = JSON.parse(reader.result)
            if (result.message)
              toast(result.message)
            else
              erroInesperado()
          };
          reader.readAsText(ex.response.data);
        } else {
          erroInesperado()
        }
      } else {
        erroInesperado()
      }
    }
  }

  const submitPorLote = async () => {
    const errors = []
    if (!data.idLote) {
      errors.push({ fieldName: 'idLote', error: 'Selecione o lote' })
    }
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }
    try {
      showLoading()
      const avisos = await relatorioService.gerarPorLote(data.idLote, data.dataInicio, data.dataFim)
      hideLoading()
      if (avisos > 0)
        setRelatorioComAvisos(true)
    } catch (ex) {
      hideLoading()
      if (ex.status == 422) {
        if (ex.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const result = JSON.parse(reader.result)
            if (result.message)
              toast(result.message)
            else
              erroInesperado()
          };
          reader.readAsText(ex.response.data);
        } else {
          erroInesperado()
        }
      } else {
        erroInesperado()
      }
    }
  }

  return (
    <Container fluid>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <h1 className="my-4">Relatórios</h1>
      </div>

      <Form onSubmit={handleSubmit}>
        <Card className="shadow mb-4">
          <CardBody>
            <TabView onTabChange={tipo => handleChange('tipo', tipo)}>
              <TabPanel label="Por Filtros" id="por_filtros">
                {(idTipoPerfil != PapelEnum.FISCAL && idTipoPerfil != PapelEnum.GESTOR_EMPRESA && idTipoPerfil != PapelEnum.GESTOR_CONTRATO) && (
                  <Row>
                    <GFComboField
                      colspan={3}
                      label="Contrato"
                      name="idContrato"
                      data={data}
                      onChange={handleChange}
                      options={contratos}
                      optionValue="id"
                      optionLabel="numero"
                      showDefault
                    />
                  </Row>
                )}
                <Row>
                  <GFTextField
                    colspan={2}
                    label="Número da OS"
                    name="numero"
                    data={data}
                    onChange={handleChange}
                    type="number"
                  />
                  <GFIntegerField
                    colspan={1}
                    label="Ano"
                    name="ano"
                    data={data}
                    onChange={handleChange}
                  />
                  <GFComboField
                    colspan={3}
                    label="Empresa"
                    name="idEmpresa"
                    data={data}
                    onChange={handleChange}
                    options={empresas}
                    optionValue="id"
                    optionLabel="razaoSocial"
                    showDefault
                    defaultValue="Todas"
                  />
                  <GFComboField
                    colspan={3}
                    label="Equipe"
                    name="idEquipe"
                    data={data}
                    onChange={handleChange}
                    options={equipes}
                    optionValue="id"
                    optionLabel="nome"
                    showDefault
                    defaultValue="Todas"
                  />
                  <GFComboField
                    colspan={3}
                    label="Status"
                    name="idStatus"
                    data={data}
                    onChange={handleChange}
                    options={statusOrdemServicoOptions}
                    optionValue="id"
                    optionLabel="nome"
                    showDefault
                    defaultValue="Todos"
                  />
                </Row>
                <Row>
                  <GFTextField
                    colspan={2}
                    label="OS Inicial"
                    name="osInicio"
                    data={data}
                    onChange={handleChange}
                    type="number"
                  />
                  <GFTextField
                    colspan={2}
                    label="OS Final"
                    name="osFim"
                    data={data}
                    onChange={handleChange}
                    type="number"
                  />
                  <GFDateField colspan={3} label="Data Inicial" name="dataInicio" data={data} onChange={handleChange} />
                  <GFDateField colspan={3} label="Data Final" name="dataFim" data={data} onChange={handleChange} />
                </Row>
                <Row>
                  <Col className="text-right">
                    <Button color="primary">Gerar</Button>
                  </Col>
                </Row>
              </TabPanel>
              {acoesUsuario.includes('relatorio.gerar_por_lote') && (
                <TabPanel label="Por Lote" id="por_lote">
                  <Row>
                    <GFDateField colspan={3} label="Data Inicial" name="dataInicio" data={data} onChange={handleChange} />
                    <GFDateField colspan={3} label="Data Final" name="dataFim" data={data} onChange={handleChange} />
                    <GFComboField
                      colspan={3}
                      label="Lote"
                      name="idLote"
                      data={data}
                      onChange={handleChange}
                      options={lotes}
                      optionValue="id"
                      optionLabel="nome"
                      showDefault
                      defaultValue="Selecione"
                    />
                  </Row>
                  {idTipoPerfil == PapelEnum.FISCAL && (
                    <Row>
                      <Col>
                        <div className="alert alert-info">
                          O relatório por lote ignora o contrato selecionado.
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col className="text-right">
                      <Button color="primary">Gerar</Button>
                    </Col>
                  </Row>
                </TabPanel>
              )}
            </TabView>
          </CardBody>
        </Card>
      </Form>
      <ModalAvisosRelatorio isOpen={relatorioComAvisos} onClosed={() => setRelatorioComAvisos(false)} />
    </Container>
  )
}
